import { FC, useState } from 'react'
import { ListItemText, MenuItem, OutlinedInput, Select, SelectProps } from '@mui/material'
import { TrendsChartSelectDropdownIcon } from 'ui/components/svg'
import { useThemeColors } from 'hooks/useThemeColors'
import { CategorySelectFormControl, getCategoryMenuProps } from './categoryPageSelectField.styles'

interface Props extends SelectProps {
  options: string[]
  value: any
  handleChange: any
  minWidth?: string
  disabled?: boolean
  dropdownWidth?: string
  anchorRight?: boolean
}

const CategoryPageSelectField: FC<Props> = ({
  options,
  handleChange,
  minWidth,
  value,
  disabled,
  dropdownWidth,
  anchorRight = false,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const getColor = useThemeColors()
  const handleClick = (event: any) => {
    if (disabled) return
    setAnchorEl(event.currentTarget)
  }

  const menuProps = getCategoryMenuProps(dropdownWidth || minWidth || '158px', anchorRight)

  return (
    <CategorySelectFormControl inputWidth={minWidth} isOpened={anchorEl ? 'true' : 'false'} isDisabled={disabled ? 'true' : 'false'}>
      <Select
        displayEmpty
        MenuProps={{
          ...menuProps,
          PaperProps: {
            ...menuProps.PaperProps,
            style: { ...menuProps.PaperProps.style, display: anchorEl ? 'block' : 'none' }
          },
          anchorEl,
          open: Boolean(anchorEl),
          onClose: () => setAnchorEl(null)
        }}
        sx={{
          minWidth,
          '& .MuiSelect-icon': { transform: anchorEl ? 'rotate(180deg)' : 'rotate(0deg)' }
        }}
        IconComponent={(props) => <TrendsChartSelectDropdownIcon {...props} />}
        renderValue={(selected) => {
          if (Array.isArray(selected)) {
            const pruned = selected.filter((s: string) => s !== '')
            if (pruned.length === 0) return rest.placeholder
            return pruned[0]
          }
          return selected
        }}
        inputProps={{ 'aria-label': 'Without label' }}
        {...rest}
        value={value}
        onChange={handleChange}
        input={<OutlinedInput onMouseDown={handleClick} />}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option} onClick={() => setAnchorEl(null)} disableRipple>
            <ListItemText primary={option} />
            {value === option && (
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M2.625 7.4375L6.125 10.9375L11.375 3.0625"
                  stroke={getColor('cta')}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </MenuItem>
        ))}
      </Select>
    </CategorySelectFormControl>
  )
}

export default CategoryPageSelectField
